export default "__VITE_ASSET__CNHfkf2i__"